import axios from 'axios';
import api from './axios';

// Existing backend contract (origin/node.js):
// POST /api/v1/plates/process, multipart field `file`.
// Relative values use the project's configured API host. Environment
// overrides remain available for deployments that expose the service under
// a gateway or a different public path.
const PLATE_RECOGNITION_URL = process.env.REACT_APP_PLATE_RECOGNITION_URL || '/plates/process';
const PLATE_IMAGE_FIELD = process.env.REACT_APP_PLATE_IMAGE_FIELD || 'file';

function getDirectProcessorUrl() {
  if (process.env.REACT_APP_PLATE_PROCESSOR_URL) return process.env.REACT_APP_PLATE_PROCESSOR_URL;
  const hostname = window.location.hostname || 'localhost';
  const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
  return `${protocol}//${hostname}:8000/api/v1/plates/process-image`;
}

export async function recognizePlate(image) {
  const body = new FormData();
  body.append(PLATE_IMAGE_FIELD, image, image.name || 'plate.jpg');
  const config = {
    // Override the shared API client's application/json default. Axios then
    // keeps the FormData body and lets the browser attach the multipart
    // boundary required by Multer.
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 30000,
  };

  try {
    const response = await api.post(PLATE_RECOGNITION_URL, body, config);
    return response.data;
  } catch (error) {
    // Some installations still run the Node checkout from before the proxy
    // route was added. Only for a missing route, call the existing FastAPI
    // processor directly; all other backend errors remain visible to users.
    if (error?.response?.status !== 404) throw error;
    const response = await axios.post(getDirectProcessorUrl(), body, config);
    return response.data;
  }
}
